import { Text } from 'blaze-ui/Text/Text'
import dayjs from 'dayjs'
import calendar from 'dayjs/plugin/calendar'

dayjs.extend(calendar)

interface Props {
  date: number | null
  label?: string
}

export const LastEditedAt = ({ date, label = '' }: Props) => {
  const lastEditedAt = date ? dayjs.unix(date) : dayjs()

  return (
    <Text variant="secondary">
      {label}{' '}
      {lastEditedAt.calendar(null, {
        sameDay: '[today], h:mma',
        lastDay: '[yesterday], h:mma',
        lastWeek: 'dddd',
        sameElse: 'MMM Do',
      })}
    </Text>
  )
}
